export enum DeviceType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop'
}

export interface DeviceInfo {
  type: DeviceType;
  width: number;
  height: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export interface DeviceBusinessInfo {
  type: DeviceType;
  isHamburgerMenuVisible: boolean;
  shouldShowMobileSearchPanel: boolean;
  needsRepositioning: boolean;
  shouldCloseHamburgerMenu: boolean;
  shouldUpdateMenuCollapseService: boolean;
  // Layout-specific properties (optional)
  shouldHideMobileSearchPanel?: boolean;
  [key: string]: any; // Allow any additional properties
}

export interface MediaQueryInfo {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
}

export interface DeviceDetectionConfig {
  enableAutoDetection: boolean;
  enableResizeListener: boolean;
  defaultDeviceType: DeviceType;
  debounceTime: number;
}
